/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ACCOUNT_PAID } from 'commons/utils/accountUtils';
import StripeSubscriptionService from 'services/StripeSubscriptionService';
import UserService from 'services/UserService';

import showNotification from 'commons/helpers/showNotification';
import StripeGetPremium from './StripeGetPremium';
import { useQuery } from 'commons/hooks/useLocationQuery';

// COMPONENT
function StripeGetPremiumForUserLoggedIn({ noBox }) {
  const [isLoadingPlan, setIsLoadingPlan] = useState(false);
  const [planList, setPlanList] = useState();
  const [isAlreadyPremium, setIsAlreadyPremium] = useState(false);
  const query = useQuery();
  const navigate = useNavigate();
  const canceledAction = query.get('cancelado');

  useEffect(() => {
    if (canceledAction) {
      showNotification('warning', 'A operação foi cancelada.');
      navigate({
        pathname: '/quero-ser-premium',
        search: '?',
      });
    }
  }, [canceledAction, navigate]);

  useEffect(() => {
    async function fetchPlanData() {
      setIsLoadingPlan(true);
      // You can await here
      try {
        const accountInfo = await UserService.getAccountStatus();
        if (accountInfo.accountType === ACCOUNT_PAID && accountInfo.paidGracePeriodEndDate == null) {
          setIsAlreadyPremium(true);
        } else {
          const planResp = await StripeSubscriptionService.getPlan();
          setPlanList(planResp);
        }
      } catch (er) {
        showNotification(
          'error',
          'Falha ao carregar plano. Por favor, recarregue a página ou entre em contato com o suporte.',
        );
      } finally {
        setIsLoadingPlan(false);
      }
      // ...
    }
    fetchPlanData();
  }, []);

  return (
    <StripeGetPremium
      isLoadingPlan={isLoadingPlan}
      planList={planList}
      isAlreadyPremium={isAlreadyPremium}
      noBox={noBox}
      createSessionForPlan={(selectedStripePlanId) => {
        return StripeSubscriptionService.createSessionForPlan(selectedStripePlanId);
      }}
    />
  );
}

export default StripeGetPremiumForUserLoggedIn;
